import http from "./http-common";

class AdminService {
    async getCompanies(filter) {
        const response = await http.get("/Admin/GetCompanies?filter=" + filter);
        return response.data;
    }

    async getDepartmentCompanies(filter) {
        const response = await http.get("/Admin/GetDepartmentCompanies?filter=" + filter);
        return response.data;
    }

    async getWorkSpaceCompanies(filter) {
        const response = await http.get("/Admin/getWorkSpaceCompanies?filter=" + filter);
        return response.data;
    }

    async getWorkSpaceCompaniesWithDeleted(filter) {
        const response = await http.get("/Admin/getWorkSpaceCompaniesWithDeleted?filter=" + filter);
        return response.data;
    }

    async getExampleCompanies(filter) {
        const response = await http.get("/Admin/GetExampleCompanies?filter=" + (filter || ''));
        return response.data;
    }

    async getAvailableExampleCompanies() {
        const response = await http.get("/Admin/GetAvailableExampleCompanies");
        return response.data;
    }

    async addExampleCompany(virtualCompanyId, departmentId) {
        const response = await http.get("/Admin/AddExampleCompany?virtualCompanyId=" + virtualCompanyId + "&departmentId=" + departmentId);
        return response.data;
    }

    async updateExampleCompany(company) {
        const response = await http.post("/Admin/UpdateExampleCompany", JSON.stringify(company));
        return response.data;
    }

    async removeExampleCompany(id) {
        const response = await http.get("/Admin/RemoveExampleCompany?id=" + id);
        return response.data;
    }

    

    async getDepartmentClubs() {
        const response = await http.get("/Admin/getDepartmentClubs");
        return response.data;
    }

    async getWorkspaceFromCurrentDepartment() {
        const response = await http.get("/Admin/GetWorkspaceFromCurrentDepartment");
        return response.data;
    }

    async getWorkspaceFromDepartment(departmentId) {
        const response = await http.get("/Admin/getWorkspaceFromDepartment?departmentId=" + departmentId);
        return response.data;
    }

    async getAllWorkspaces() {
        const response = await http.get("/Admin/GetAllWorkspaces");
        return response.data;
    }

    async getAdminWorkspaces() {
        const response = await http.get("/Admin/GetAdminWorkspaces");
        return response.data;
    }

    async getWorkspaceUsers() {
        const response = await http.get("/Admin/getWorkspaceUsers");
        return response.data;
    }

    async deleteCompany(companyId) {
        const response = await http.get("/Admin/deleteCompany?companyId=" + companyId);
        return response.data;
    }

    async setCompanyDeleted(companyId) {
        const response = await http.get("/Admin/setCompanyDeleted?companyId=" + companyId);
        return response.data;
    }

    async setCompanyActive(companyId) {
        const response = await http.get("/Admin/setCompanyActive?companyId=" + companyId);
        return response.data;
    }

    async copyCompany(companyIdToCopy, name) {
        const response = await http.get("/Admin/copyCompany?companyIdToCopy=" + companyIdToCopy + "&name=" + name);
        return response.data;
    }
    async createCompany(company) {
        const response = await http.post("/Admin/createCompany", JSON.stringify(company));
        return response.data;
    }

    async createCompanyFromExample(company) {
        const response = await http.post("/Admin/CreateCompanyFromExample", JSON.stringify(company));
        return response.data;
    }

    async createWorkspaceCompanyFromExample(company) {
        const response = await http.post("/Admin/CreateWorkspaceCompanyFromExample", JSON.stringify(company));
        return response.data;
    }

    async createWorkspaceCompanyFromMediumExample(company) {
        const response = await http.post("/Admin/CreateWorkspaceCompanyFromMediumExample", JSON.stringify(company));
        return response.data;
    }

    async createWorkspaceCompanyFromLargeExample(company) {
        const response = await http.post("/Admin/CreateWorkspaceCompanyFromLargeExample", JSON.stringify(company));
        return response.data;
    }

    async createWorkspaceCompany(company) {
        const response = await http.post("/Admin/CreateWorkspaceCompany", JSON.stringify(company));
        return response.data;
    }
    
    /*
    async getCompany(companyId) {
        const response = await http.get("/Admin/GetCompany?companyId=" + companyId);
        return response.data;
    }*/
    async updateCompany(company) {
        const response = await http.post("/Admin/UpdateCompany", JSON.stringify(company));
        return response.data;
    }
    async getAllUsers() {
        const response = await http.get("/Admin/GetAllUsers");
        return response.data;
    }
    async getUser(userId) {
        const response = await http.get("/Admin/GetUser?userId=" + userId);
        return response.data;
    }
    async createUser(user) {
        const response = await http.post("/Admin/CreateUser", JSON.stringify(user));
        return response.data;
    }
    async createUserWorkspace(user) {
        const response = await http.post("/Admin/CreateUserWorkspace", JSON.stringify(user));
        return response.data;
    }
    async createUserDepartment(user) {
        const response = await http.post("/Admin/CreateUserDepartment", JSON.stringify(user));
        return response.data;
    }
    async createUserAdmin(user) {
        const response = await http.post("/Admin/CreateUserAdmin", JSON.stringify(user));
        return response.data;
    }
    async updateUser(user) {
        const response = await http.post("/Admin/UpdateUser", JSON.stringify(user));
        return response.data;
    }
    async deleteUser(userId) {
        const response = await http.get("/Admin/DeleteUser?userId=" + userId);
        return response.data;
    }
    async getDepartments() {
        const response = await http.get("/Admin/GetDepartments");
        return response.data;
    }
    async deleteDepartment(departmentId) {
        const response = await http.get("/Admin/DeleteDepartment?departmentId=" + departmentId);
        return response.data;
    }
    async createDepartment(department) {
        const response = await http.post("/Admin/CreateDepartment", JSON.stringify(department));
        return response.data;
    }
    async updateDepartment(department) {
        const response = await http.post("/Admin/UpdateDepartment", JSON.stringify(department));
        return response.data;
    }


    async deleteClub(clubId) {
        const response = await http.get("/Admin/DeleteClub?clubId=" + clubId);
        return response.data;
    }
    async createClub(club) {
        const response = await http.post("/Admin/createClub", JSON.stringify(club));
        return response.data;
    }

    async updateClub(club) {
        const response = await http.post("/Admin/UpdateClub", JSON.stringify(club));
        return response.data;
    }


    async deleteWorkspace(workspaceId) {
        const response = await http.get("/Admin/DeleteWorkspace?workspaceId=" + workspaceId);
        return response.data;
    }

    async getNews() {
        const response = await http.get("/Admin/GetNews");
        return response.data;
    }

    async createNews(news) {
        const response = await http.post("/Admin/CreateNews", JSON.stringify(news));
        return response.data;
    }

    async updateNews(news) {
        const response = await http.post("/Admin/UpdateNews", JSON.stringify(news));
        return response.data;
    }

    async deleteNews(newsId) {
        const response = await http.get("/Admin/DeleteNews?newsId=" + newsId);
        return response.data;
    }

    async createWorkspace(workspace) {
        const response = await http.post("/Admin/CreateWorkspace", JSON.stringify(workspace));
        return response.data;
    }
    async createWorkspaceInCurrentDepartment(workspace) {
        const response = await http.post("/Admin/CreateWorkspaceInCurrentDepartment", JSON.stringify(workspace));
        return response.data;
    }
    async updateWorkspace(workspace) {
        const response = await http.post("/Admin/UpdateWorkspace", JSON.stringify(workspace));
        return response.data;
    }
    async getClubs() {
        const response = await http.get("/Admin/GetClubs");
        return response.data;
    }
    async getClubsFromDepartment(departmentId) {
        const response = await http.get("/Admin/GetClubsFromDepartment?departmentId=" + departmentId);
        return response.data;
    }
    async getClubsFromCurrentDepartment() {
        const response = await http.get("/Admin/GetClubsFromCurrentDepartment");
        return response.data;
    }
    async getWorkspacesFromClub(clubId) {
        const response = await http.get("/Admin/GetWorkspaces?clubId=" + clubId);
        return response.data;
    }
    async updateAnalysisCriterias(analysisCriterias) {
        const response = await http.post("/Admin/UpdateAnalysisCriterias", JSON.stringify(analysisCriterias));
        return response.data;
    }
    async getAnalysisCriterias() {
        const response = await http.get("/Admin/GetAnalysisCriterias");
        return response.data;
    }
    async getAllLogEntries() {
        const response = await http.get("/Admin/GetAllLogEntries");
        return response.data;
    }
    async getAllLogEntriesByDate(startDate, endDate) {
        const response = await http.get("/Admin/GetAllLogEntriesByDate?startDate=" + startDate + "&endDate=" + endDate);
        return response.data;
    }
    async getCompanyLogEntriesByDate(startDate, endDate) {
        const response = await http.get("/Admin/GetCompanyLogEntriesByDate?startDate=" + startDate + "&endDate=" + endDate);
        return response.data;
    }
    
    async getLogEntriesFromDepartment() {
        const response = await http.get("/Admin/GetLogEntriesFromDepartment");
        return response.data;
    }
    async getLogEntriesFromDepartmentByDate(startDate, endDate) {
        const response = await http.get("/Admin/GetLogEntriesFromDepartmentByDate?startDate=" + startDate + "&endDate=" + endDate);
        return response.data;
    }
    async getLogEntriesFromWorkspace() {
        const response = await http.get("/Admin/GetLogEntriesFromWorkspace");
        return response.data;
    }
    async getLogEntriesFromWorkspaceByDate(startDate, endDate) {
        const response = await http.get("/Admin/GetLogEntriesFromWorkspaceByDate?startDate=" + startDate + "&endDate=" + endDate);
        return response.data;
    }
    async getCurrentVirtualCompany() {
        const response = await http.get("/Admin/getCurrentVirtualCompany");
        var data = response.data;
        return data;
    }

    async getAllPermissions() {
        const response = await http.get("/Admin/GetAllPermissions");
        return response.data;
    }

    async getPermissions() {
        const response = await http.get("/Admin/GetPermissions");
        return response.data;
    }

    async addPermissionForDepartment(permissionLevel, permissionType, readPermission, writePermission, modifyPermission, departmentId) {
        const response = await http.get("/Admin/addPermissionForDepartment?permissionLevel=" + permissionLevel + "&permissionType=" + permissionType + "&readPermission=" + readPermission + "&writePermission=" + writePermission + "&modifyPermission=" + modifyPermission + "&departmentId=" + departmentId);
        return response.data;
    }

    async addPermission(permissionLevel, permissionType, readPermission, writePermission, modifyPermission) {
        const response = await http.get("/Admin/addPermission?permissionLevel=" + permissionLevel + "&permissionType=" + permissionType + "&readPermission=" + readPermission + "&writePermission=" + writePermission + "&modifyPermission=" + modifyPermission);
        return response.data;
    }

    async deletePermission(permissionId) {
        const response = await http.get("/Admin/deletePermission?permissionId=" + permissionId);
        return response.data;
    }
    
}

export default new AdminService();
